import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import Level3Title from '../../../../../app/common/components/title/Level3Title';
import Badge from '../../../../../app/common/components/Badge';
import Button from '../../../../../Components/Button';
import {useAutoDismissMessage} from '../../../Hooks/useAutoDismissMessage';

/**
 * MAQUETTE — onglet « Gérer vos messages » d'une prestation Trunk SIP.
 * Données statiques : aucun appel API.
 */
const GererMessages = (): JSX.Element => {
  const intl = useIntl();
  const [message, setMessage] = useAutoDismissMessage();

  return (
    <div className="mt-4">
      <Card>
        <Card.Header className="d-flex align-items-center gap-3">
          <Card.Title className="m-0">
            <Level3Title title={intl.formatMessage({id: 'TELEPHONIE.MESSAGES.TITLE'})} />
          </Card.Title>
          <Badge text="0" color="primary" light size="small" />
        </Card.Header>
        <Card.Body className="text-center py-10">
          <i className="bi bi-voicemail fs-3x text-muted d-block mb-4" />
          <div className="text-muted fs-6 mb-5">
            {intl.formatMessage({id: 'TELEPHONIE.MESSAGES.AUCUN_MESSAGE'})}
          </div>
          {message && <div className="fw-bold text-danger mb-3">{message}</div>}
          <Button
            label={intl.formatMessage({id: 'TELEPHONIE.MESSAGES.RAFRAICHIR'})}
            faIcon="bi bi-arrow-clockwise fs-6 me-2"
            onClick={() =>
              setMessage(intl.formatMessage({id: 'TELEPHONIE.MESSAGES.RAFRAICHI'}))
            }
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default GererMessages;
